import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
export var CollisionsOverlap = /*#__PURE__*/function () {
  function CollisionsOverlap() {
    _classCallCheck(this, CollisionsOverlap);
    this.enable = true;
    this.retries = 0;
  }
  _createClass(CollisionsOverlap, [{
    key: "load",
    value: function load(data) {
      if (!data) {
        return;
      }
      if (data.enable !== undefined) {
        this.enable = data.enable;
      }
      if (data.retries !== undefined) {
        this.retries = data.retries;
      }
    }
  }]);
  return CollisionsOverlap;
}();